export default __webpack_public_path__ + "static/media/George_team.26ed2d72.jpg";